
import { Component, Vue, Prop } from 'vue-property-decorator';

import { stepInfoType } from "@/types/Application";
import PageBase from "@/components/steps/PageBase.vue";
import GetHelpForPdf from "@/components/steps/submit/helpPages/GetHelpForPDF.vue";
import FormList from "@/components/steps/submit/components/FormList.vue";
import Tooltip from "@/components/survey/Tooltip.vue";


@Component({
    components:{
        PageBase,
        GetHelpForPdf,
        FormList,
        Tooltip
    }
})
export default class ReviewAndConnect extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    currentStep =0;
    currentPage =0;   
    showGetHelpForPDF = false;
    isSch1Downloaded = false;

    mounted(){
        this.isSch1Downloaded = false;
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        let progress = this.$store.state.Application.steps[this.currentStep].pages[this.currentPage].progress
        
        if(progress==0) progress=50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);       

    } 

    public downloadSchedule1(){
        const pdf_name='pfa722-schedule1'
        const url = '/print-fillable-pdf?name='+pdf_name
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdf_name+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000); 
            this.isSch1Downloaded = true;

        },err => {
            console.error(err);
        });
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage()     
    }

    beforeDestroy() {
        const progress = 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
    }

}
